module.exports = __webpack_public_path__ + "static/img/10.4574b39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/10.png
// module id = L7f1
// module chunks = 0